<template>
	<ModalWrapperXLBodyScroll id="modal-reconnect" :show-header="true" :show-footer="false" custom-class="app-modal-danger">
		<template #title><h4 class="m-0 text-center">¡Ups! Hemos perdido la conexión</h4></template>

		<div class="container">
			<div class="d-flex flex-column justify-content-center align-items-center">
				<p class="text-center">
					¡Vaya! Parece que nuestra conexión se interrumpió. <br />
					Por favor, intenta recargar la página. Si el problema continúa, contáctanos y con gusto te ayudaremos.
				</p>

				<div class="d-grid gap-2 col-6 mx-auto">
					<button class="btn btn-primary" type="button" @click="refreshPage">Recargar</button>
				</div>
			</div>
		</div>
	</ModalWrapperXLBodyScroll>
</template>

<script>
import ModalWrapperXLBodyScroll from "@/components/utils/modalWrapper/ModalWrapperXLBodyScroll.vue";

export default {
	name: "ModalReconnect",
	components: { ModalWrapperXLBodyScroll },
	data() {
		return {
			visible: true,
		};
	},
	methods: {
		refreshPage() {
			window.location.reload();
		},
	},
	mounted() {},
	beforeUnmount() {},
};
</script>

<style scoped></style>
